var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoonFilled = function SvgMoonFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 3c-4.968 0-9 4.032-9 9s4.032 9 9 9c1.638 0 3.177-.45 4.5-1.215C14.809 18.228 13 15.33 13 12s1.809-6.228 5.5-7.785A9 9 0 0 0 14 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 12C4 6.48 8.48 2 14 2c1.823 0 3.534.501 5 1.35a1 1 0 0 1-.111 1.786C15.547 6.546 14 9.095 14 12s1.547 5.454 4.889 6.864A1 1 0 0 1 19 20.65 10 10 0 0 1 14 22C8.48 22 4 17.52 4 12m10-8c-4.416 0-8 3.584-8 8s3.584 8 8 8c.76 0 1.495-.109 2.193-.31C13.417 17.864 12 15.106 12 12s1.417-5.864 4.193-7.69A8 8 0 0 0 14 4",
    clipRule: "evenodd"
  })));
};
export default SvgMoonFilled;